import { createLocationOptionsGetter } from '../LocationOptionHelpers/LocationOptionHelpers';

interface ProvinceType {
    name: string;
    isoCode: string;
}

const provinceMap: Record<string, ProvinceType> = {
    'AB': {
        name: 'Alberta',
        isoCode: 'AB'
    },
    'BC': {
        name: 'British Columbia',
        isoCode: 'BC'
    },
    'MB': {
        name: 'Manitoba',
        isoCode: 'MB'
    },
    'NB': {
        name: 'New Brunswick',
        isoCode: 'NB'
    },
    'NL': {
        name: 'Newfoundland and Labrador',
        isoCode: 'NL'
    },
    'NS': {
        name: 'Nova Scotia',
        isoCode: 'NS'
    },
    'ON': {
        name: 'Ontario',
        isoCode: 'ON'
    },
    'PE': {
        name: 'Prince Edward Island',
        isoCode: 'PE'
    },
    'QC': {
        name: 'Quebec',
        isoCode: 'QC'
    },
    'SK': {
        name: 'Saskatchewan',
        isoCode: 'SK'
    },
    'NT': {
        name: 'Northwest Territories',
        isoCode: 'NT'
    },
    'NU': {
        name: 'Nunavut',
        isoCode: 'NU'
    },
    'YT': {
        name: 'Yukon',
        isoCode: 'YT'
    }
};

export const getProvinceOptions = createLocationOptionsGetter(provinceMap);

export default provinceMap;